import type { WorkspacePageLayoutMode } from '@/components/canvas/workspace/model/workspacePageLayoutMode';

/** 横向布局时旋转翻页图标，使其与 +X 铺排方向一致 */
export function pageChromeNavIconClass(
  layoutMode: WorkspacePageLayoutMode,
  _which: 'prev' | 'next',
): string | undefined {
  if (layoutMode !== 'horizontal') return undefined;
  // 上一页（▲）与下一页（▼）均逆时针 90°，在横向布局中分别指向左、右
  return '-rotate-90';
}
